/**
 * No-op healthcheck for the web port. There is no external watchdog
 * (no `app_watchdog.sh` analog in a browser tab), so `ping()` is a no-op.
 */
export class StubHealthcheck {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    async ping() { }
}
//# sourceMappingURL=StubHealthcheck.js.map